import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'icon',
  'title',
  'description',
  'link',
  'linkWrapper',
  'freeformSymbol',
]);

/**
 * Icon styles. Variant 'valueProp' when Icon is inside IconSet explainer blocks.
 * Desktop (KINDW-1026 / design): title 24px (2xl), body 14px (sm). Mobile: icon 48×48, title 20px / heading.h3 (xl), line-height 150%, body 12/Body Reg.
 */
export const iconStyles = helpers.defineMultiStyleConfig({
  baseStyle({component: _}) {
    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      },
      icon: {
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
      },
      title: {
        marginTop: 4,
        textAlign: 'center',
        fontSize: {base: 'lg', lg: '1.5xl'},
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: {base: 0, lg: 'labelTight'},
      },
      description: {
        marginTop: 0,
        textAlign: 'center',
        fontSize: {base: 'xs', lg: 'md'},
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: {base: '140%', lg: '160%'},
      },
      link: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        textDecoration: 'none',
      },
      linkWrapper: {
        width: '100%',
      },
    };
  },
  variants: {
    /** Value Prop: explainer blocks — desktop title 24px, body 14px (KINDW-1026). */
    valueProp: {
      root: {
        gap: {base: 2, md: 4},
      },
      icon: {
        width: {base: 12, md: 16},
        height: {base: 12, md: 16},
        flexShrink: 0,
        objectFit: 'contain',
      },
      title: {
        marginTop: 0,
        // Repeat lg+ so merged baseStyle title (lg: 1.5xl) does not win on wide viewports
        // KINDW-1026: mobile title 20px (Figma Mobile/text.heading.h3), desktop 24px (2xl)
        fontSize: {base: 'xl', md: '2xl', lg: '2xl', xl: '2xl', '2xl': '2xl'},
        fontWeight: 500,
        lineHeight: {base: 1.5, md: 1.2},
        letterSpacing: {base: 0, md: 'labelTight', lg: 'labelTight'},
        textAlign: 'center',
        color: 'inherit',
      },
      description: {
        fontSize: {base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'},
        fontWeight: 400,
        lineHeight: {base: 1.4, md: 1.6},
        textAlign: 'center',
        marginTop: 0,
        // Inherit Icon Set Style `textColour` from the section wrapper.
        color: 'inherit',
      },
      freeformSymbol: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1.2em',
        height: '1.2em',
        borderWidth: 0.25,
        borderStyle: 'solid',
        borderColor: 'currentColor',
        borderRadius: '50%',
        fontSize: '0.7em',
        fontFamily: 'inherit',
        fontWeight: 400,
        verticalAlign: 'super',
        marginLeft: '0.06em',
        marginRight: '0.04em',
        lineHeight: 0,
      },
    },
  },
});
